// extracted by mini-css-extract-plugin
module.exports = {"label":"JobsViewV2_label__2U-69","header":"JobsViewV2_header__3uiw6"};